import { H3 } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { RouteLink } from '@/components/RouteLinks/RouteLinks';
import { addImageParams, AddImageParamTypes } from '@/utils/urls';

type Props = {
    imageUrl: string;
    link: string;
    title: string;
};

export const CategoryCard = ({ imageUrl, link, title }: Props) => {
    const imageParams: AddImageParamTypes = {
        height: 160,
        url: imageUrl,
    };

    return (
        <div
            className={cn(
                // standard layout
                'mt-md flex justify-center',
                // mobile
                'xsMax:w-[calc(50%-8px)]',
                // tablet
                'smMax:w-[calc(33.333%-10px)]',
                // desktop
                'w-[calc(25%-15px)]'
            )}
        >
            <RouteLink
                className="relative block w-full bg-background-primary no-underline"
                to={link}
            >
                <div className="mb-xs w-full justify-center overflow-hidden bg-background-subdued p-sm">
                    <img
                        alt={title}
                        className="m-auto max-h-full max-w-full"
                        loading="lazy"
                        src={addImageParams(imageParams)}
                    />
                </div>
                <H3 className="text-left">{title}</H3>
            </RouteLink>
        </div>
    );
};
